import Havena1 from "./H10x15  (1).webp";
import Havena2 from "./H10x15  (2).webp";
import Havena3 from "./H10x15  (3).webp";
import Havena4 from "./H10x15  (4).webp";
import Havena5 from "./H10x15  (5).webp";

const Havena10images = [Havena1, Havena2, Havena3, Havena4, Havena5];

export default Havena10images;
